import { AnimaliaDetailNarrativeBlockDTO } from '../../../../application/mappers/AnimaliaDetailMapper';
import { animaliaDetailDesignTokens } from '../shared/animalia-detail-design-tokens';

export class MvAnimaliaDetailNarrative extends HTMLElement {
  private blocks: ReadonlyArray<AnimaliaDetailNarrativeBlockDTO> = [];

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  setBlocks(blocks: ReadonlyArray<AnimaliaDetailNarrativeBlockDTO>): void {
    this.blocks = [...blocks];
    this.render();
  }

  connectedCallback(): void {
    this.render();
  }

  private render(): void {
    if (!this.shadowRoot) {
      return;
    }

    this.shadowRoot.innerHTML = `
      <style>
        ${animaliaDetailDesignTokens}

        .story-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 18px;
          margin-top: 34px;
        }

        .story-card {
          display: grid;
          grid-template-columns: 64px minmax(0, 1fr);
          gap: 18px;
          padding: 22px;
        }

        .story-number {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: linear-gradient(135deg, #dfd5c5, rgba(95, 120, 128, 0.18));
          display: grid;
          place-items: center;
          color: #31463d;
          font-weight: 700;
        }

        h2,
        h3 {
          margin: 0;
          font-family: Georgia, 'Times New Roman', serif;
        }

        h2 {
          margin-top: 8px;
          color: #31463d;
          font-size: clamp(1.8rem, 2.6vw, 2.8rem);
        }

        h3 {
          margin-top: 8px;
          font-size: 1.55rem;
          color: #31463d;
        }

        p:last-child {
          margin: 10px 0 0;
          line-height: 1.78;
          color: rgba(32, 39, 32, 0.64);
        }

        @media (max-width: 720px) {
          .story-card {
            grid-template-columns: 1fr;
            padding-left: 16px;
            padding-right: 16px;
          }
        }
      </style>

      <section>
        <header>
          <p class="section-kicker">Narrativa</p>
          <h2>Bloques editoriales</h2>
        </header>
        <div class="story-grid">
          ${this.blocks
            .map(
              (block) => `
                <article class="story-card editorial-panel">
                  <span class="story-number">${this.escapeHtml(block.indexLabel)}</span>
                  <div>
                    <h3>${this.escapeHtml(block.title)}</h3>
                    <p>${this.escapeHtml(block.body)}</p>
                  </div>
                </article>
              `,
            )
            .join('')}
        </div>
      </section>
    `;
  }

  private escapeHtml(value: string): string {
    return value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }
}

if (!customElements.get('mv-animalia-detail-narrative')) {
  customElements.define('mv-animalia-detail-narrative', MvAnimaliaDetailNarrative);
}
